export default function SectionHeading({
  eyebrow,
  title,
  highlight,
  description,
  centered = false,
  light = false,
}) {
  return (
    <div className={centered ? "text-center" : ""}>
     {eyebrow && (
  <div className="mb-5 inline-flex items-center font-montserrat gap-3 rounded-full border border-[#e0e7ff] bg-[#f6f4ff] px-4 py-2 text-[11px] font-bold uppercase tracking-[0.22em] text-[#4C42FD]">
    <span className="h-1.5 w-1.5 rounded-full bg-[#4C42FD]" />
    {eyebrow}
  </div>
)}
      <h2
        className={`text-[2.25rem] font-black font-montserrat leading-[1.05] tracking-[-0.03em] sm:text-5xl lg:text-6xl ${light ? "text-white" : "text-[#0d0828]"
          }`}
      >
        {title}
        {highlight ? (
          <>
            <br />
            <span className={`${light ? "text-white" : "bg-gradient-to-r font-montserrat text-[#4C42FD] bg-clip-text"
              }`}>
              {highlight}
            </span>
          </>
        ) : null}
      </h2>

      {description ? (
        <p
          className={`mt-5 text-base font-montserrat leading-7 sm:text-lg ${centered ? "mx-auto max-w-3xl" : "max-w-2xl"
            } ${light ? "text-white/70" : "text-[#0d0828b3]"}`}
        >
          {description}
        </p>
      ) : null}
    </div>
  );
}
